import React, { Component } from "react";
import {
  Typography,
  Paper,
  Tabs as Tabs1,
  Tab as Tab1,
} from "@material-ui/core";
import { Tabs, Tab } from "react-bootstrap";
import { GetData } from "../../api/service";
import AcademicAbout from "../Academics/AcademicAbout";
import PhotosOther from "../Photos/PhotosOther";
import DepartmentAchievements from "../Department/DepartmentAchievements";
import DepartmentActivity from "../Department/DepartmentActivity";
import CollegeEventShort from "../College/CollegeEventShort";
import CollegeGB from "../College/CollegeGB";

const smallTab = [
  {
    title: "About",
    active: 0,
  },
  {
    title: "Management Committee",
    active: 1,
  },
  {
    title: "Program & Intake",
    active: 2,
  },

  {
    title: "Faculty & Administrative Staff",
    active: 3,
  },
  {
    title: "NCTE",
    active: 4,
  },
  {
    title: "Faculty Left or Join",
    active: 5,
  },
  {
    title: "Student Enrollment",
    active: 6,
  },
  {
    title: "Land Documents",
    active: 7,
  },
  {
    title: "Library",
    active: 8,
  },
  {
    title: "Fee Structure",
    active: 9,
  },

  {
    title: "Relevant Document",
    active: 10,
  },
  {
    title: "Infrastructure Facilities",
    active: 11,
  },
];

class ItepHomeLanding extends Component {
  state = {
    active: 0,
    dept_code: "PRAG",

    data: {},
    isDeptLoaded: false,
  };

  __getDeptData = (dept_code) => {
    GetData(`/admin/${dept_code}/getsingledeptdata`).then((resp) => {
      //console.log(resp)
      if (resp != false) {
        this.setState({
          data: resp,
          active: 0,
          isDeptLoaded: true,
        });
      } else {
        this.setState({
          data: {},
          active: 0,
          isDeptLoaded: true,
        });
      }
    });
  };

  componentDidMount() {
    this.__getDeptData(this.state.dept_code);
  }

  render() {
    return (
      <div>
        <Typography variant="h6">
          Integrated Teacher Education Programme
        </Typography>
        <Typography variant="subtitle2">
          Code: {this.state.dept_code}
        </Typography>

        <br />

        {this.state.isDeptLoaded && (
          <Paper square>
            <Tabs1
              value={this.state.active}
              indicatorColor="primary"
              textColor="primary"
              onChange={(e, newValue) =>
                this.setState({
                  active: newValue,
                })
              }
              aria-label=""
            >
              {smallTab.map((el, index) => (
                <Tab1 style={{fontSize: 12}} value={el.active} key={el.active} label={el.title} />
              ))}
            </Tabs1>
          </Paper>
        )}
        <br />
        {this.state.active == 0 ? (
          <AcademicAbout type={`ITEP_ABOUT`} title="Add ITEP Courses" />
        ) : null}

        {this.state.active == 1 ? (
          <div>
            <CollegeEventShort
              dept_code={"PRAG"}
              dept_name={"Webadmin"}
              {...this.props}
              title="Add Management Committee"
              type={"ITEP_COMMITTEE"}
            />
          </div>
        ) : null}

        {this.state.active == 2 ? (
          <AcademicAbout
            type={`ITEP_PROGRAM_INTAKE`}
            title="Program & Intake"
          />
        ) : null}

        {this.state.active == 3 ? (
          <div>
            <CollegeEventShort
              dept_code={"PRAG"}
              dept_name={"Webadmin"}
              {...this.props}
              title="Add Faculty & Administrative Staff"
              type={"ITEP_FACULTY_STAFF"}
            />
          </div>
        ) : null}

        {this.state.active == 4 ? (
          <div>
            <CollegeEventShort
              dept_code={"PRAG"}
              dept_name={"Webadmin"}
              {...this.props}
              title="NCTE"
              type={"ITEP_NCTE"}
            />
          </div>
        ) : null}

        {this.state.active == 5 ? (
          <div>
            <CollegeEventShort
              dept_code={"PRAG"}
              dept_name={"Webadmin"}
              {...this.props}
              title="Faculty Left or Join"
              type={"ITEP_FACULTY_LEFT_JOIN"}
            />
          </div>
        ) : null}

        {this.state.active == 6 ? (
          <div>
            <CollegeEventShort
              dept_code={"PRAG"}
              dept_name={"Webadmin"}
              {...this.props}
              title="Student Enrollment"
              type={"ITEP_STUDENT_ENROLLMENT"}
            />
          </div>
        ) : null}

        {this.state.active == 7 ? (
          <div>
            <CollegeEventShort
              dept_code={"PRAG"}
              dept_name={"Webadmin"}
              {...this.props}
              title="Land Documents"
              type={"ITEP_LAND_DOCUMENTS"}
            />
          </div>
        ) : null}

        {this.state.active == 8 ? (
          <AcademicAbout type={`ITEP_LIBRARY`} title="Library" />
        ) : null}

        {this.state.active == 9 ? (
          <AcademicAbout type={`ITEP_FEES_STRUCTURE`} title="Fees Structure" />
        ) : null}

        {this.state.active == 10 ? (
          <div>
            <CollegeEventShort
              dept_code={"PRAG"}
              dept_name={"Webadmin"}
              {...this.props}
              title="Relevant Document"
              type={"ITEP_RELEVANT_DOCUMENT"}
            />
          </div>
        ) : null}


        {this.state.active == 9 ? (
          <AcademicAbout type={`ITEP_INFRASTRUCTURE`} title="Infrastructure Facilities" />
        ) : null}
      </div>
    );
  }
}

export default ItepHomeLanding;
